import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Shift } from '@wilson/interfaces';
import {
  RemoveShiftWithoutActivitiesFromCellViewUnassignedRegion,
  RemoveShiftWithoutActivitiesFromUnassignedRegion,
  TimelineRemoveShiftFromUserV2,
} from '@wilson/shift-timeline/state';
import { TimelineCommonOperationsService } from './timeline-common-operations.service';

@Injectable({
  providedIn: 'root',
})
export class DeleteShiftCommonOperationsService {
  private readonly store = inject(Store);
  private readonly timelineCommonOperationsService = inject(
    TimelineCommonOperationsService,
  );

  public handleCellViewDeleteOperation(shift: Shift & { id: string }): void {
    if (shift.userId) {
      this.deleteShiftFromAssignedRegion(shift, shift.userId);
    } else {
      this.store.dispatch(
        new RemoveShiftWithoutActivitiesFromCellViewUnassignedRegion({
          shiftId: shift.id,
        }),
      );
    }
  }

  public handleStandardViewDeleteOperation(
    shift: Shift & { id: string },
  ): void {
    if (shift.userId) {
      this.deleteShiftFromAssignedRegion(shift, shift.userId);
    } else {
      this.store.dispatch(
        new RemoveShiftWithoutActivitiesFromUnassignedRegion({
          shiftId: shift.id,
        }),
      );
    }
  }

  private deleteShiftFromAssignedRegion(
    shift: Shift & { id: string },
    userId: string,
  ): void {
    this.store.dispatch(
      new TimelineRemoveShiftFromUserV2({
        shiftId: shift.id,
        userId,
      }),
    );

    this.timelineCommonOperationsService.updateProductivityAndKpisOfUsers([
      userId,
    ]);
  }
}
